export default {
	namespaced: true,
	state: {
		info: null
	},
	getters: {
		info(state) {
			return state.info;
		}
	},
	actions: {
		setInfo({ commit }, info) {
			commit('setInfo', info);
		}
	},
	mutations: {
		setInfo(state, info) {
			state.info = info;
		}
	}
}